<template>
  <div ref="reactRoot"></div>
</template>

<script>
  import { ReactManager } from '../../../../../frontendV2/dist/reactComponents.js';

  export default {
    name: 'ReactWrapper',

    props: {
      component: {
        type: Function,
        required: true,
      },
      props: {
        type: Object,
      },
    },

    data: () => ({
      routerContext: null,
    }),

    watch: {
      props() {
        this._reactInstance?.updateProps(this.props);
      },
      $route() {
        if (this.routerContext) {
          this.routerContext.route = this.$route;
          this._reactInstance?.updateProps(this.props);
        }
      },
    },

    created() {
      this.routerContext = this.createRouterContext();
      this._reactInstance = new ReactManager(this.component, {
        routerContext: this.routerContext,
      });
    },

    mounted() {
      this._reactInstance.mount(this.$refs.reactRoot, this.props);
    },

    beforeDestroy() {
      this._reactInstance?.unmount();
    },

    methods: {
      createRouterContext() {
        if (typeof window === 'undefined' || !this.$router) {
          return null;
        }

        return {
          router: this.$router,
          route: this.$route,
        };
      },
    },
  };
</script>
